export const mocaConfig: Array<{
  name: keyof Omit<IMOCA, keyof IControlProps>;
  options: Array<string>;
  description: boolean;
}> = [
  {
    name: 'visuospatialExecutive',
    options: ['connectDots', 'copyCube', 'contour', 'numbers', 'hands'],
    description: false,
  },
  {
    name: 'naming',
    options: ['lion', 'rhino', 'camel'],
    description: false,
  },
  {
    name: 'memory',
    options: [],
    description: true,
  },
  {
    name: 'attentionNumbers',
    options: ['forwards', 'backwards'],
    description: true,
  },
  {
    name: 'attentionLetters',
    options: ['pass'],
    description: true,
  },
  {
    name: 'attentionSubtraction',
    options: ['93', '86', '79', '72', '65'],
    description: true,
  },
  {
    name: 'language',
    options: ['first', 'second', 'fluency'],
    description: false,
  },
  {
    name: 'abstraction',
    options: ['first', 'second'],
    description: false,
  },
  {
    name: 'delayedRecall',
    options: ['first', 'second', 'third', 'fourth', 'fifth'],
    description: false,
  },
  {
    name: 'orientation',
    options: ['date', 'month', 'year', 'day', 'place', 'city'],
    description: false,
  },
];
